import Fetch from "../../utils/Fetch";
export default {
    namespaced: true,
    state: {
        notifications: null,
    },
    mutations: {
        setNotifications(state, data) {
            state.notifications = data
        },
    },
    actions: {
        async requestNotifications({commit, state}) {
            if (state.notifications) return
            const response = await Fetch('personal/notifications/', {
                method: 'GET',
            });

            if (response.success) {
                commit('setNotifications', response.data)
            }

            return {
                ...response
            }
        },
    },
    getters: {
        getNotifications: state => state.notifications,
    }
} 